export default __webpack_public_path__ + "0159be9eabf21ea434c21c299614b5d1.png";